// import store from "@/store/store";
export const formatMoney = (amount) => {
  let numberFormatConfig = undefined;
  var money = "";
  if (!amount || isNaN(amount)) {
    money = 0;
  } else if (amount < 0) {
    let cloneAmout = -amount;
    if (cloneAmout < 1) {
      money = cloneAmout.toString().replace(".", ",");
    } else if (cloneAmout.toString().includes(".")) {
      money = cloneAmout
        .toString()
        .replace(".", ",")
        .replace(/\d(?=(\d{3})+\,)/g, "$&.");
    } else {
      money = cloneAmout.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
    }
  } else if (amount < 1) {
    money = amount.toString().replace(".", ",");
  } else if (amount.toString().includes(".")) {
    money = amount
      .toString()
      .replace(".", ",")
      .replace(/\d(?=(\d{3})+\,)/g, "$&.");
  } else {
    money = amount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
  }
  if (numberFormatConfig) {
    if (numberFormatConfig.thousandsSeparatorCharacter == ",") {
      money = money.toString().replaceAll(".", "#");
      money = money.toString().replaceAll(",", ".");
      money = money.toString().replaceAll("#", ",");
    }
    if (amount < 0) {
      let numberFormatConfig = undefined;
      if (numberFormatConfig) {
        if (numberFormatConfig.negativeNumberDisplay == "(n)") {
          money = "(" + money + ")";
        } else {
          money = "-" + money;
        }
        return money;
      } else money = "(" + money + ")";
    }
    return money;
  }
  return money;
};
